const standaloneTypes = [
  'other',
  'consulting',
  'property_management',
];

export function isStandalone({ dealType }) {
  return standaloneTypes.includes(dealType) ;
}

export function getLocation(object) {
  const parts = [];

  if (object.state) {
    parts.push(object.state);
  }

  if (object.zip) {
    parts.push(object.zip);
  }

  if (object.city) {
    if (parts.length) {
      parts.unshift(`${object.city},`);
    } else {
      parts.unshift(object.city);
    }
  }

  return parts.join(' ');
}

export function getDescription(deal) {
  let description = deal.name || '';

  if (deal.address) {
    if (description.length) {
      description += ' ';
    }

    description += deal.address;
  }

  const location = getLocation(deal);
  if (location.length > 0) {
    if (description.length) {
      description += ', ';
    }

    description += location;
  }

  return description;
}
